module.exports = __webpack_public_path__ + "static/media/akc1.8cc156d5.png";